import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Task from "../Task";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { actionCreators } from "./action";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import renderTask from '../TaskEngine/renderTask';

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing(3),
    width: "100%"
  },
  formControlNoMargin: {
    margin: theme.spacing(0),
    width: "100%"
  }
}));

function Tasks(props) {
  const projectId = props.projectId;

  const classes = useStyles();
  const [state, setState] = React.useState({
    gilad: true,
    jason: false,
    antoine: false
  });

  const [open, setOpen] = React.useState(true);

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const { gilad, jason, antoine } = state;
  const error = [gilad, jason, antoine].filter(v => v).length !== 2;

  const [doneCounter, setDoneCounter] = React.useState(0);

  const [width, setWidth] = React.useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth({ width: window.innerWidth });
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
  });

  useEffect(() => {
    if (window.innerWidth <= 500) {
      setOpen(false);
    }
    window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  const isMobile = width <= 500;

  return (
    <div className={classes.root}>
      <FormControl
        required
        error={error}
        component="fieldset"
        className={isMobile ? classes.formControlNoMargin : classes.formControl}
      >
        {!props.done ? <>
          <FormLabel>{props.category ? props.category : "inbox"}</FormLabel>
          <FormGroup>
            {props.tasks &&
              Object.keys(props.tasks).map((value, id) => {

                const task = props.tasks[value];
                
                const taskComponent = !task.project && (
                  task.id && renderTask(task, props)
                );
                const withProjectTaskComponent = projectId
                  ? task.parent === projectId && taskComponent
                  : taskComponent;

                return props.inbox
                  ? !task.focus && !task.done && !task.parent && !task.action && withProjectTaskComponent
                  : props.focus
                    ? task.focus && !task.done && withProjectTaskComponent
                    : !task.done && withProjectTaskComponent;
              })}
          </FormGroup>
        </> :
        
          <>
            <FormLabel onClick={handleClick}><Button onClick={handleClick} >done
         {open ? <ExpandLess onClick={handleClick} /> : <ExpandMore onClick={handleClick} />}</Button></FormLabel>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <FormGroup>
                {props.tasks &&
                  Object.keys(props.tasks).map((value, id) => {
                    const task = props.tasks[value];
                    const taskComponent = () => {
                      return (!task.project &&
                        <Task
                          {...task}
                          label={task.title}
                          checked={task.done}
                          onClick={() => props.updateTask(task.id)}
                          onClickFocus={() => props.toggleStar(task.id)}
                          key={task.id}
                        />
                      )
                    };

                    const withProjectTaskComponent = projectId
                      ? task.parent === projectId && taskComponent()
                      : taskComponent();

                    return props.inbox
                      ? !task.focus && task.done && !task.parent && !task.action && withProjectTaskComponent
                      : props.focus
                        ? task.focus && task.done && withProjectTaskComponent
                        : task.done && withProjectTaskComponent;
                  })}
              </FormGroup>
            </Collapse>
          </>}
      </FormControl>
    </div>
  );
}

const mapStateToProps = (state, props) => {
  function isInCategory(idTask) {
    const task = state.tasks[idTask];
    return task.action === props.category;
  }

  const tasks = state.tasks && Object.keys(state.tasks)
    .filter(isInCategory)
    .map(key => {
      const priority = state.tasks[key].priority ? state.tasks[key].priority : 0;
      return ({ ...state.tasks[key], priority });
    });

  const tasksRest = state.tasks && Object.keys(state.tasks).map(key => {
    const priority = state.tasks[key].priority ? state.tasks[key].priority : 0;
    return ({ ...state.tasks[key], priority });
  });


  return {
    tasks: props.category ? reverse(sortBy(tasks, ['priority'])) : reverse(sortBy(tasksRest, ['priority']))
  };
};

export default connect(mapStateToProps, actionCreators)(Tasks);
